module.exports = function() {
  function handleRemove(event) {
    var row = $(event.target).closest(".lineitem")
    var index = row.data("index")

    row.append("<input type='hidden' name='invoice[lines_attributes][" + index + "][_destroy]' value='true' />")
        .hide();

    return false;
  }

  $("#add-line").click(function () {
    var template = $('#lineitem-template').html().replace(/{{id}}/g, Date.now());

    var line = $(template);

    $("#lineitems").append(line);

    $(line.find("a")).click(handleRemove);
    $(line.find("select")).select2();
  });

  $(".lineitem a").click(handleRemove);
  $(".lineitem select").select2();
}